import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topbar w-full flex flex-row bg-white p-2 shadow-sm h-[57px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-auto" }, null, -1)
const _hoisted_3 = { class: "flex flex-none w-[15rem]" }

import SelectShop from "@/components/ui/SelectShop.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SelectShop)
    ])
  ]))
}
}

})